import { takeEvery, put, call } from "redux-saga/effects"

// Calender Redux States
import {
  GET_ARTICLE,
  GET_ARTICLE_DETAILS,
  ADD_NEW_ARTICLE,
  UPDATE_ARTICLE,
  DELETE_ARTICLE,
} from "./actionTypes";

import {
  getArticleSuccess,
  getArticleFail,
  getArticleDetailsSuccess,
  getArticleDetailsFail,
  addArticleFail,
  addArticleSuccess,
  updateArticleSuccess,
  updateArticleFail,
  deleteArticleSuccess,
  deleteArticleFail,
} from "./actions"

import {
  articleListingApi,
  articleDetailsApi,
  addNewArticle,
  updateArticle,
  delArticle,
} from "./articleApi.js"

function* fetchArticle({ payload: length, page }) {
  try {
    const response = yield call(articleListingApi, length, page)
    yield put(getArticleSuccess(response))
  } catch (error) {
    yield put(getArticleFail(error))
  }
}

function* fetchArticleDetails({ payload: id }) {
  try {
    const response = yield call(articleDetailsApi, id)
    yield put(getArticleDetailsSuccess(response))
  } catch (error) {
    yield put(getArticleDetailsFail(error))
  }
}

function* onAddNewArticle({ payload: article }) {
  try {
    const response = yield call(addNewArticle, article)
    yield put(addArticleSuccess(response))
  } catch (error) {
    yield put(addArticleFail(error))
  }
}

function* onUpdateArticle({ payload: id, article }) {
  try {
    const response = yield call(updateArticle, id, article)
    yield put(updateArticleSuccess(response))
  } catch (error) {
    yield put(updateArticleFail(error))
  }
}

function* onDelArticle({ payload: id }) {
  try {
    const response = yield call(delArticle, id)
    yield put(deleteArticleSuccess(response))
  } catch (error) {
    yield put(deleteArticleFail(error))
  }
}

function* ArticleSaga() {
  yield takeEvery(GET_ARTICLE, fetchArticle)
  yield takeEvery(GET_ARTICLE_DETAILS, fetchArticleDetails)
  yield takeEvery(ADD_NEW_ARTICLE, onAddNewArticle)
  yield takeEvery(UPDATE_ARTICLE, onUpdateArticle)
  yield takeEvery(DELETE_ARTICLE, onDelArticle)
}

export default ArticleSaga
